/*
    Description: contact overlay class
    Author URI: https://www.adillice.com
    Author: adillice
    Version: 1.0.0
*/

// import utility
import Utility from "./utility";

// extend utility class
class Contact extends Utility{

    // constructor
    constructor({
        // add selectors
        contactClass = "contact__overlay",
        contactFormClass = "contact__overlay__wrapper__form",
        contactResultsClass = "contact__overlay__wrapper__results",
        submitBttnClass = "contact__overlay__wrapper__form__submit__input",
        contactLinkClass = "contact__wrapper__copy",
        closeClass = "contact__overlay__close",
        hideClass = "--js-contact-hide",
        noScrollClass = "--js-noscroll",
        jsOpenClass = "--js-open-contact",
        loadingClass = "--loading",
        successClass = "--success",
        errorClass = "--error"
    } = {}){
        
        // call parent constructor
        super();

        // contact wrapper
        this.contact = document.querySelector(`.${contactClass}`);
        
        // contact form wrapper
        this.form = document.querySelector(`.${contactFormClass}`);

        // get contact link DOM element
        this.contactLink = document.querySelector(`.${contactLinkClass}`);

        // results area
        this.results = document.querySelector(`.${contactResultsClass}`);

        // get submit button
        this.submitButton = document.querySelector(`.${submitBttnClass}`);

        // get close button
        this.closeButton = document.querySelector(`.${closeClass}`);

        // get body tag
        this.body = document.getElementsByTagName("body");

        // get other links to open overlay
        this.otherLinks = document.querySelectorAll(`.${jsOpenClass}`);

        // set noScroll class
        this.noScroll = noScrollClass;

        // hide 
        this.hide = hideClass;

        // error
        this.loading = loadingClass;
        
        // success
        this.success = successClass;

        // error
        this.error = errorClass;

        // current contact link clicked to open overlay 
        this.clickedContactBttn = null;

        // stop form process
        this.halt = false;

        // run evnts
        this.events();

    }

    // run all events
    events(){

        // make sure we have the main contact wrapper
        if(!this.contact) return;

        // form submission event
        if(this.form) this.form.addEventListener("submit", this.processForm.bind(this));
        
        // enable close event
        if(this.closeButton) this.closeButton.addEventListener("click", this.closeOverlay.bind(this));
        
        // contact link clicked or on enter
        if(this.contactLink) this.contactLink.addEventListener("click", this.linkEvent.bind(this));
        if(this.contactLink) this.contactLink.addEventListener("keydown", this.enterOpen.bind(this));

        // trap focus
        if(this.contact && (typeof this.trapFocus === "function")) this.trapFocus(this.contact);

        // enter press check on element
        if(this.contact && (typeof this.pressEnterClose === "function")) this.pressEnterClose(this.closeButton, this.closeOverlay.bind(this));
        
        // make sure we have other links
        if(this.otherLinks){

            // loop: thru links
            for(const link of this.otherLinks){

                // add event to link
                link.addEventListener("click", this.linkEvent.bind(this));

            }
            
        }

    }

    // link click event
    linkEvent(e){

        // prevent default action
        e.preventDefault();

        // update currently clicked contact bttn
        this.clickedContactBttn = e.target;

        // process form
        this.openOverlay();

    }

    // create form
    processForm(e){

        // prevent default behavior
        e.preventDefault();

        // prevent form process if already submitted form
        if(this.halt) return;

        // set self to this
        const self = this,

        // get submit button class list
        submitClasses = self.submitButton.classList;
  
        // STOP MULTI CLICKS: prevent users calling to API
        if(submitClasses.contains(self.loading)) return;

        // add loading icon
        submitClasses.add(self.loading);

        // ajax call
        self.ajax({
            
            // send data
            data:new FormData(self.form),
            
            // url
            action:"contact-us",
        
        // promise results 
        }).then((results) => {

            // remove loading icon
            submitClasses.remove(self.loading);

            // clear results area
            this.results.innerHTML = "";

            // create p tag
            const p = document.createElement("p");

            // add tab index to p
            p.setAttribute("tabindex", 0);

            // SUCCESS
            if(results.success){

                // add success class
                p.classList.add(this.success);

                // add success msg
                p.textContent = results.success;

                // add msg to results area
                this.results.append(p); 

                // focus on results
                if(this.results.children) this.results.children[0].focus();

                // no more form submissions (for now)
                this.halt = true;

                // reset form
                this.resetForm();

            }
            
            // ERRORS
            if(results.error){

                // add error class to text
                p.classList.add(this.error);

                // MAILCHIMP ERROR
                if(results.error.mailchimp){
                    
                    // create clone
                    const mailChimpError = p.cloneNode();

                    // add error msg
                    mailChimpError.textContent = (results.error.mailchimp.detail) ? results.error.mailchimp.detail : results.error.mailchimp.title;
                    
                    // append to results area
                    this.results.append(mailChimpError);
                    
                    // focus on results
                    if(this.results.children) this.results.children[0].focus();

                // ALL OTHER ERRORS
                }else{

                    // LOOP: error msgs
                    for(const err in results.error){
                        
                        // create clone
                        const thisError = p.cloneNode();

                        // add error msg
                        thisError.textContent = results.error[err];
                        
                        // append to results area
                        this.results.append(thisError);

                        // focus on results
                        if(this.results.children) this.results.children[0].focus();          

                    }

                }

            }
            
        // catch error
        }).catch((err) => {
            
            // clear results area
            this.results.innerHTML = "";

            // create p tag
            const p = document.createElement("p");

            // remove loading icon
            submitClasses.remove(self.loading);

            // add error msg
            p.textContent = err;
            
            // append to results area
            this.results.append(p);

            // focus on results
            if(this.results.children) this.results.children[0].focus();

        });

    }

    // clear fields
    resetForm(){

        // init input
        const inputs = this.form.querySelectorAll("input[type=text], textarea");

        // init index
        let i = 0, len = inputs.length;

        // LOOP: thru fields
        for(i; i < len; i++){
            
            // clear inputs
            inputs[i].value = "";
            
        }
        
    }

    // display overlay when user hits enter
    enterOpen(e){

        // check for bttn
        if(!e) return;

        // get current key
        const thisKey = e.key.toLowerCase() || e.keyCode,

        // get active element
        active = document.activeElement;

        // check if focus is on search icon and user hits enter 
        if((active == e.target) && (thisKey == "enter" || thisKey == 13)){
            
            // set clicked bttn
            this.clickedContactBttn = e.target;

            // open overlay
            this.openOverlay(e);

        }

    }

    // open overlay
    openOverlay(){
            
        // reset form
        this.resetForm();

        // reset form process
        this.halt = false;

        // remove hide class
        if(this.contact) this.contact.classList.remove(this.hide);
    
        // update attributes
        if(this.contact) this.contact.setAttribute("aria-hidden", false);
        if(this.contact) this.contact.setAttribute("tabindex", 0);

        // focus on close button
        if(this.closeButton) this.closeButton.focus();

        // add no scroll to body
        if(this.body && this.body[0]) this.body[0].classList.add(this.noScroll);

    }

    // close overlay 
    closeOverlay(e){

        // end case
        if(!this.closeButton) return;

        // prevent default behavior
        e.preventDefault();

        // add hide class
        if(this.contact) this.contact.classList.add(this.hide);

        // update attributes
        if(this.contact) this.contact.setAttribute("aria-hidden", true);
        if(this.contact) this.contact.setAttribute("tabindex", -1);

        // clear results area
        if(this.results) this.results.innerHTML = "";

        // remove no scroll from body tag
        if(this.body && this.body[0]) this.body[0].classList.remove(this.noScroll);

        // focus link to clicked contact link
        if(this.clickedContactBttn != null) this.clickedContactBttn.focus();

        // reset form
        this.resetForm();

    }

}

// export module
export default Contact;